
import graphemeLength from '@/lib/graphemeLength';

export default {
  name: 'AppTextarea',
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, required: true },
    rows: { type: Number, default: 8 },
    maxlength: { type: Number, default: 2000 },
    resizable: { type: Boolean, default: true },
    invalid: { type: Boolean, default: false },
    showLength: { type: Boolean, default: true },
    variant: {
      type: String,
      default: 'default',
      validator: v => ['default', 'bare'].includes(v)
    }
  },
  computed: {
    valueLength() {
      return graphemeLength(this.value);
    }
  },
  watch: {
    value: {
      handler() {
        if (this.resizable) {
          this.$nextTick(this.fitHeightToContent);
        }
      },
      immediate: true
    }
  },
  methods: {
    fitHeightToContent() {
      const BORDER_HEIGHT = 2;
      const { textarea } = this.$refs;

      textarea.style.setProperty('height', 'auto');
      const oldRows = textarea.rows;
      textarea.rows = this.rows;
      textarea.style.setProperty(
        'height',
        `${textarea.scrollHeight + BORDER_HEIGHT}px`
      );
      textarea.rows = oldRows;
    }
  }
};
